import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _addRequest = {};
var _addResponse = {};
var _getRequest = {};
var _getResponse = {};
var _listGroupsByEventIdRequest = {};
var _listGroupsByEventIdResponse = {};
var _listGroupsByEventIdsRequest = {};
var _listGroupsByEventIdsResponse = {};
var _removeRequest = {};
var _removeResponse = {};
function resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function listEvents(payload) {
    var _a = serializer(_getRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getResponse, {}).fromJSON;
    function __listEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.group_event',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsEventsMappingService.listEvents',
            url: resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/events',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listEvents.fromReq = fromReq;
    __listEvents.__isAmbassador = true;
    return __listEvents;
}
export function listGroupsByEventId(payload) {
    var _a = serializer(_listGroupsByEventIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupsByEventIdResponse, {}).fromJSON;
    function __listGroupsByEventId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.group_event',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsEventsMappingService.listGroupsByEventId',
            url: resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl({
                protoPath: '/api/v1/groups/queryByEventId',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupsByEventId.fromReq = fromReq;
    __listGroupsByEventId.__isAmbassador = true;
    return __listGroupsByEventId;
}
export function listGroupsByEventIds(payload) {
    var _a = serializer(_listGroupsByEventIdsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listGroupsByEventIdsResponse, {}).fromJSON;
    function __listGroupsByEventIds(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.group_event',
            method: 'GET',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsEventsMappingService.listGroupsByEventIds',
            url: resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl({
                protoPath: '/api/v1/groups/queryByEventIds',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listGroupsByEventIds.fromReq = fromReq;
    __listGroupsByEventIds.__isAmbassador = true;
    return __listGroupsByEventIds;
}
export function addEvents(payload) {
    var _a = serializer(_addRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_addResponse, {}).fromJSON;
    function __addEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.group_event',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsEventsMappingService.addEvents',
            url: resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/events/add',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __addEvents.fromReq = fromReq;
    __addEvents.__isAmbassador = true;
    return __addEvents;
}
export function removeEvents(payload) {
    var _a = serializer(_removeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeResponse, {}).fromJSON;
    function __removeEvents(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.social_groups.v1.group_event',
            method: 'POST',
            methodFqn: 'wix.social.groups.api.v1.SocialGroupsEventsMappingService.removeEvents',
            url: resolveWixSocialGroupsApiV1SocialGroupsEventsMappingServiceUrl({
                protoPath: '/api/v1/groups/{groupId}/events/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeEvents.fromReq = fromReq;
    __removeEvents.__isAmbassador = true;
    return __removeEvents;
}
//# sourceMappingURL=http.impl.js.map